// Hook for production analytics cookie consent banner state and actions.
import { useCallback, useState } from 'react';
import { initAnalytics, isProduction } from '@/services/analyticsService';
import {
  getAnalyticsConsent,
  setAnalyticsConsent,
} from '@/services/analyticsConsent';

/**
 * @returns {{
 *   visible: boolean;
 *   onAccept: () => Promise<void>;
 *   onReject: () => void;
 * }}
 */
export function useCookieConsentBanner() {
  const [dismissed, setDismissed] = useState(false);

  const stored = getAnalyticsConsent();
  const visible =
    isProduction() && !dismissed && stored === null;

  const onAccept = useCallback(async () => {
    if (!setAnalyticsConsent('accepted')) {
      setDismissed(true);
      return;
    }
    setDismissed(true);
    await initAnalytics();
  }, []);

  const onReject = useCallback(() => {
    if (setAnalyticsConsent('rejected')) {
      setDismissed(true);
      return;
    }
    setDismissed(true);
  }, []);

  return { visible, onAccept, onReject };
}
